/* VEXiAL — «Comprar por WhatsApp»: el producto que el cliente tiene elegido.
   ============================================================
   MONEDA.md §7.3. El checkout de Shopify cobra en dólares. En soles,
   «Comprar ahora» —en la ficha y en el pop-up de agregar rápido— pasa a
   «Comprar por WhatsApp» y abre el chat de la tienda con ese producto: la
   variante elegida, la cantidad y el total en soles.

   No toca el carrito. Lo que hubiera en él no entra en el mensaje: para
   pagar el carrito entero está «Pagar por WhatsApp», en el carrito.

   El número, la plantilla y la URL de la tienda llegan de Liquid en
   window.VX_WHATSAPP (snippets/vx-moneda-head.liquid). El sol de la variante
   lo pasa quien llama, con el precio fijado a mano si lo hay (MONEDA.md
   §2.5); si no llega, se convierte. El total es la unidad por la cantidad,
   como una línea del carrito (§4.1).

   Solo se carga con la moneda encendida. Apagada, window.VXPagoWhatsApp no
   existe y «Comprar ahora» va al checkout, como siempre.
   ============================================================ */
(function () {
  'use strict';

  var PLANTILLA = 'Hola, VEXiAL. Quiero comprar en soles:\n\n{producto}\nCantidad: {cantidad}\nTotal: {total}\n\n{enlace}';

  function activo() {
    return !!(window.VXMoney && window.VXMoney.active() === 'pen' && window.VX_WHATSAPP && window.VX_WHATSAPP.numero);
  }

  /* datos.titulo       el título del producto
     datos.variante     el nombre de la variante («1200x1200mm / Español»),
                        vacío en un producto de una sola variante
     datos.cantidad     la del selector
     datos.precioCents  el precio de la variante, en centavos de dólar
     datos.penCentimos  su sol en céntimos, si Liquid lo publicó
     datos.url          la del producto, relativa («/products/…»)
     datos.variantId    el id de la variante
     Devuelve false si no pudo armar el mensaje. */
  function comprar(datos) {
    if (!activo() || !datos) return false;
    var M = window.VXMoney;
    var W = window.VX_WHATSAPP;

    var cantidad = Math.max(1, parseInt(datos.cantidad, 10) || 1);
    var unidad = datos.penCentimos != null && Number(datos.penCentimos) >= 0
      ? Number(datos.penCentimos)
      : M.toPen(datos.precioCents);
    if (unidad == null || !isFinite(unidad)) return false;

    var url = String(datos.url || '');
    if (datos.variantId) url += (url.indexOf('?') < 0 ? '?' : '&') + 'variant=' + datos.variantId;
    var valores = {
      producto: String(datos.titulo || '') + (datos.variante ? ' (' + datos.variante + ')' : ''),
      cantidad: String(cantidad),
      precio: M.formatPen(unidad),
      total: M.formatPen(unidad * cantidad),
      enlace: String(W.tienda || window.location.origin).replace(/\/+$/, '') + url
    };

    var plantilla = W.plantilla && String(W.plantilla).trim() ? String(W.plantilla) : PLANTILLA;
    var texto = plantilla
      .replace(/\r\n/g, '\n')
      .replace(/\{(producto|cantidad|precio|total|enlace)\}/g, function (marca, clave) {
        return valores[clave];
      });

    var destino = 'https://wa.me/' + W.numero + '?text=' + encodeURIComponent(texto);
    var pestana = null;
    try { pestana = window.open(destino, '_blank'); } catch (e) { pestana = null; }
    if (pestana) {
      try { pestana.opener = null; } catch (e) { /* ya es de otro origen */ }
    } else {
      window.location.href = destino;
    }
    return true;
  }

  window.VXPagoWhatsApp = { activo: activo, comprar: comprar };
})();
